/* eslint-disable no-return-assign */
import { assign } from 'xstate';

// defaults
export const defaultLinkState = { url: null, hash: null };

// ACTIONS

export const markActive = assign({
    isInactive: (context) => (context.isInactive = false),
});

export const markInactive = assign({
    isInactive: (context) => (context.isInactive = true),
});

export const markEditorNotDirty = assign({
    isDirty: (context) => (context.isDirty = false),
    isPreviewDisabled: (context) => (context.isPreviewDisabled = false),
});

export const markPostSuccess = assign({
    postSuccess: (context) => (context.postSuccess = true),
});

export const setError = assign({
    error: (context, event) =>
        (context.error = event.data.errors || [
            'Something went wrong. Please try your post again.',
        ]),
});

export const clearError = assign({
    error: (context) => (context.error = []),
});

export const syncEditorUpdates = assign({
    isDirty: (context) => (context.isDirty = true),
    isInactive: (context) => (context.isInactive = false),
    postText: (context, event) => (context.postText = event.postText),
    html: (context, event) => (context.html = event.html),
    link: (context, { links = [] }) =>
        (context.link = {
            // if has link, no image, and didn't delete preview
            url:
                links?.length > 0 &&
                !context?.image &&
                !context.isPreviewDisabled
                    ? links[0]
                    : null,
            hash: !context.isPreviewDisabled ? context.link.hash : null,
        }),
    hashtags: (context, event) => {
        if (!event.postText) return [];

        const element = document.createElement('div');
        element.innerHTML = event.html;
        const hashtags = Array.from(
            element.querySelectorAll('.editor-hashtag')
        ).map((hashtagEl) => hashtagEl.textContent.trim());
        context.hashtags = hashtags;
    },
    uploadError: (context) => (context.uploadError = false),
});

// fires on RESET event
export const resetEditor = assign({
    isDirty: (context) => (context.isDirty = false),
    isInactive: (context) => (context.isInactive = true),
    postText: (context) => (context.postText = ''),
    html: (context) => (context.html = ''),
    isAnonymousPost: (context) => (context.isAnonymousPost = false),
    image: (context) => (context.image = null),
    link: (context) => (context.link = defaultLinkState),
    hashtags: (context) => (context.hashtags = []),
    isPreviewDisabled: (context) => (context.isPreviewDisabled = false),
    type: (context) => (context.type = 'Discussion'),
    postSuccess: (context) => (context.postSuccess = false),
    error: (context) => (context.error = []),
    communityGroupHash: (context) => (context.communityGroupHash = ''),
    photoButtonClicks: (context) => (context.photoButtonClicks = 0),
    uploadError: (context) => (context.uploadError = []),
});

export const resetEditorAfterError = assign({
    isDirty: (context) => (context.isDirty = false),
    isInactive: (context) => (context.isInactive = true),
    postText: (context) => (context.postText = ''),
    html: (context) => (context.html = ''),
    isAnonymousPost: (context) => (context.isAnonymousPost = false),
    image: (context) => (context.image = null),
    link: (context) => (context.link = defaultLinkState),
    hashtags: (context) => (context.hashtags = []),
    isPreviewDisabled: (context) => (context.isPreviewDisabled = false),
    type: (context) => (context.type = 'Discussion'),
    postSuccess: (context) => (context.postSuccess = false),
    communityGroupHash: (context) => (context.communityGroupHash = ''),
    photoButtonClicks: (context) => (context.photoButtonClicks = 0),
    uploadError: (context) => (context.uploadError = []),
});

// Fires on DISABLE_PREVIEW event
export const disableLinkPreview = assign({
    isPreviewDisabled: (context) => (context.isPreviewDisabled = true),
    type: (context) => (context.type = 'Discussion'),
});

// Fires on TOGGLE_POST_ANONYMITY event
export const togglePostAnonymity = assign({
    isAnonymousPost: (context) =>
        (context.isAnonymousPost = !context.isAnonymousPost),
});

export const saveEmbedlyData = assign({
    link: (context, event) =>
        (context.link = { url: event.url, hash: event.hash }),
    type: (context) => (context.type = 'Link'),
});

export const setLinkToDefault = assign({
    link: (context) => (context.link = defaultLinkState),
});

// Fires on SELECT_POST_GROUP
export const selectPostGroup = assign({
    communityGroupHash: (context, { value }) =>
        (context.communityGroupHash = value),
});

export const setImageUrl = assign({
    image: (context, { value }) => (context.image = value),
});

export const setImageToDefault = assign({
    image: (context) => (context.image = null),
});

export const setPhotoButtonClickCounter = assign({
    photoButtonClicks: (context) => context.photoButtonClicks + 1,
});

export const setUploadError = assign({
    uploadError: (context, error) =>
        (context.uploadError = error.data.errors || [
            'Something went wrong. Please try your post again.',
        ]),
});

export const clearUploadError = assign({
    uploadError: (context) => (context.uploadError = []),
});
